import React from 'react';
import styled from 'styled-components';
import { devices, theme } from 'styles/theme';
import Link from 'next/link';

const Social = ({iconColor, facebook, twitter, instra, linkedin, youtube, pinterest, bg, hoverbg, iconhover}) => {


    return (

        <StyledSocial iconhover={iconhover} className={'social-item-wrapper'}>
            <ul className={'social'}>
                {
                    facebook &&
                    <li><Link href={facebook || 'facebook'} prefetch={true}
                              target={'_blank'} rel="noreferrer">
                        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle opacity="0.5" cx="21" cy="21" r="20" stroke="#F4F4F4" />
                            <g clipPath="url(#clip0_395_593)">
                                <path d="M25.1513 22.0368L25.6118 19.0352H22.7338V17.0877C22.7141 16.8636 22.745 16.638 22.8241 16.4274C22.9032 16.2168 23.0286 16.0267 23.191 15.8711C23.3534 15.7155 23.5487 15.5983 23.7624 15.5281C23.9761 15.458 24.2028 15.4368 24.4258 15.4659H25.7354V12.9125C24.9672 12.7876 24.191 12.7191 23.4128 12.7075C21.0404 12.7075 19.4903 14.1421 19.4903 16.7475V19.0352H16.8535V22.0368H19.4903V29.2929H22.7351V22.0368H25.1513Z" fill="#F4F4F4" />
                            </g>
                            <defs>
                                <clipPath id="clip0_395_593">
                                    <rect width="16.5854" height="16.5854" fill="white" transform="translate(12.707 12.7075)" />
                                </clipPath>
                            </defs>
                        </svg>


                    </Link>
                    </li>

                }

                {
                    twitter &&
                    <li><Link prefetch={true} href={twitter || '/'}
                              target={'_blank'} rel="noreferrer">

                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="30" height="30" rx="4" fill="white" />
                            <path d="M16.6769 13.6218L23.2337 6H21.68L15.9867 12.6179L11.4395 6H6.19482L13.0711 16.0074L6.19482 24H7.74867L13.7609 17.0113L18.5631 24H23.8078L16.6765 13.6218H16.6769ZM14.5487 16.0956L13.852 15.0991L8.30854 7.16971H10.6952L15.1688 13.5689L15.8655 14.5655L21.6807 22.8835H19.2941L14.5487 16.096V16.0956Z" fill="#152637" />
                        </svg>

                    </Link>
                    </li>

                }

                {
                    instra &&
                    <li><Link prefetch={true} href={instra || '/'}
                              target={'_blank'} rel="noreferrer">
                        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle opacity="0.5" cx="21" cy="21" r="20" stroke="#F4F4F4" />
                            <g clipPath="url(#clip0_395_597)">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M18.3715 29.2929H24.604C25.8472 29.2914 27.0391 28.7661 27.9181 27.8321C28.7972 26.8981 29.2917 25.6317 29.293 24.3109V17.6888C29.2915 16.3681 28.7969 15.1019 27.9179 14.1681C27.0389 13.2342 25.8471 12.709 24.604 12.7075H18.3715C17.1285 12.709 15.9368 13.2342 15.0577 14.1681C14.1787 15.1019 13.6842 16.3681 13.6826 17.6888V24.3109C13.684 25.6317 14.1784 26.8981 15.0575 27.8321C15.9366 28.7661 17.1283 29.2914 18.3715 29.2929ZM16.0962 15.2722C16.6999 14.6308 17.5185 14.2701 18.3722 14.2692H24.6047C25.4584 14.2701 26.277 14.6308 26.8807 15.2722C27.4844 15.9135 27.8241 16.7831 27.8251 17.6902V24.3123C27.8243 25.2195 27.4847 26.0893 26.8809 26.7308C26.2772 27.3722 25.4585 27.733 24.6047 27.7339H18.3722C17.5184 27.733 16.6997 27.3722 16.096 26.7308C15.4922 26.0893 15.1526 25.2195 15.1518 24.3123V17.6902C15.1528 16.7831 15.4925 15.9135 16.0962 15.2722ZM25.621 15.6692C25.4399 15.6691 25.2629 15.726 25.1122 15.8328C24.9616 15.9396 24.8442 16.0914 24.7748 16.2691C24.7054 16.4468 24.6872 16.6424 24.7224 16.8311C24.7577 17.0199 24.8448 17.1932 24.9728 17.3293C25.1008 17.4654 25.2639 17.5581 25.4415 17.5957C25.6191 17.6333 25.8032 17.6141 25.9705 17.5405C26.1378 17.4669 26.2808 17.3422 26.3814 17.1822C26.4821 17.0223 26.5358 16.8342 26.5358 16.6418C26.5358 16.5141 26.5122 16.3877 26.4663 16.2697C26.4203 16.1517 26.353 16.0444 26.268 15.9541C26.1831 15.8638 26.0822 15.7921 25.9712 15.7432C25.8602 15.6944 25.7411 15.6692 25.621 15.6692ZM21.5537 16.9156C20.7935 16.9158 20.0504 17.1554 19.4183 17.6042C18.7863 18.0531 18.2937 18.691 18.0028 19.4372C17.7119 20.1835 17.6358 21.0047 17.7842 21.7969C17.9325 22.5891 18.2986 23.3168 18.8362 23.888C19.3737 24.4591 20.0587 24.8481 20.8043 25.0057C21.5499 25.1633 22.3227 25.0825 23.0251 24.7735C23.7275 24.4644 24.3279 23.941 24.7503 23.2695C25.1727 22.5979 25.3983 21.8084 25.3984 21.0006C25.3974 19.9175 24.992 18.8791 24.2712 18.1133C23.5504 17.3474 22.5731 16.9167 21.5537 16.9156ZM21.5537 23.6167C21.0667 23.6167 20.5907 23.4633 20.1858 23.1758C19.7809 22.8884 19.4653 22.4798 19.279 22.0017C19.0926 21.5237 19.0438 20.9977 19.1388 20.4902C19.2338 19.9828 19.4683 19.5166 19.8126 19.1507C20.157 18.7849 20.5957 18.5357 21.0733 18.4348C21.551 18.3338 22.0461 18.3856 22.496 18.5837C22.9459 18.7817 23.3304 19.117 23.6009 19.5472C23.8715 19.9774 24.0159 20.4832 24.0159 21.0006C24.0153 21.6942 23.7556 22.3592 23.294 22.8497C22.8324 23.3401 22.2065 23.616 21.5537 23.6167Z"
                                      fill="#F4F4F4" />
                            </g>
                            <defs>
                                <clipPath id="clip0_395_597">
                                    <rect width="15.6098" height="16.5854" fill="white" transform="translate(13.6826 12.7075)" />
                                </clipPath>
                            </defs>
                        </svg>


                    </Link>
                    </li>
                }

                {

                    youtube &&
                    <li><Link prefetch={true} href={youtube || '/'}
                              target={'_blank'} rel="noreferrer">
                        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle opacity="0.5" cx="21" cy="21" r="20" stroke="#F4F4F4" />
                            <g clipPath="url(#clip0_395_608)">
                                <path d="M29.2924 19.1118C29.2924 18.6338 29.2037 18.1605 29.0316 17.7189C28.8595 17.2774 28.6072 16.8761 28.2891 16.5382C27.971 16.2002 27.5934 15.9321 27.1778 15.7492C26.7622 15.5663 26.3168 15.4722 25.8669 15.4722H17.1082C16.1997 15.4722 15.3284 15.8556 14.686 16.5382C14.0436 17.2207 13.6826 18.1465 13.6826 19.1118V23.4429C13.6826 24.4082 14.0436 25.3339 14.686 26.0164C15.3284 26.699 16.1997 27.0825 17.1082 27.0825H25.8669C26.3168 27.0825 26.7622 26.9883 27.1778 26.8054C27.5934 26.6225 27.971 26.3544 28.2891 26.0164C28.6072 25.6785 28.8595 25.2773 29.0316 24.8357C29.2037 24.3941 29.2924 23.9208 29.2924 23.4429V19.1118ZM24.142 21.6016L20.214 23.6661C20.0605 23.7543 19.5367 23.6364 19.5367 23.4499V19.2117C19.5367 19.0236 20.0642 18.9049 20.2177 18.9986L23.9775 21.1716C24.1332 21.2676 24.3014 21.5095 24.142 21.6016Z" fill="#F4F4F4" />
                            </g>
                            <defs>
                                <clipPath id="clip0_395_608">
                                    <rect width="15.6098" height="16.5854" fill="white" transform="translate(13.6826 12.7075)" />
                                </clipPath>
                            </defs>
                        </svg>


                    </Link></li>

                }

                {
                    linkedin &&
                    <li>
                        <Link href={linkedin || '/'} prefetch={true} target={'_blank'} rel="noreferrer">

                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle opacity="0.5" cx="21" cy="21" r="20" stroke="#F4F4F4" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M21.4242 18.33V19.7442C21.7203 19.2931 22.1285 18.9266 22.6088 18.6806C23.0891 18.4346 23.625 18.3175 24.1642 18.3408C27.0433 18.3408 27.6658 20.1408 27.6658 22.4825V27.25H24.9992V23.0233C24.9992 22.015 24.7958 20.7183 23.2258 20.7183C21.7033 20.7183 21.4433 21.8158 21.4433 22.9483V27.25H18.785V18.33H21.4242ZM16.9992 16.0883C16.9988 16.3525 16.9205 16.6107 16.7741 16.8305C16.6276 17.0504 16.4195 17.2221 16.1758 17.3242C15.9323 17.4254 15.6641 17.4519 15.4054 17.4002C15.1468 17.3486 14.9093 17.2212 14.7233 17.0342C14.537 16.847 14.4101 16.609 14.3587 16.35C14.3072 16.0909 14.3335 15.8225 14.4343 15.5784C14.535 15.3342 14.7056 15.1253 14.9248 14.9779C15.1439 14.8306 15.4017 14.7513 15.6658 14.75C15.8413 14.75 16.0151 14.7847 16.1772 14.852C16.3393 14.9193 16.4865 15.0179 16.6104 15.1423C16.7343 15.2666 16.8324 15.4142 16.8991 15.5766C16.9658 15.7389 16.9998 15.9128 16.9992 16.0883Z" fill="#F4F4F4" />
                                <path d="M16.9997 18.3408H14.333V27.25H16.9997V18.3408Z" fill="#F4F4F4" />
                            </svg>

                        </Link>
                    </li>
                }

                {
                    pinterest &&
                    <li>
                        <Link prefetch={true} href={pinterest || '/'} target={'_blank'} rel="noreferrer">

                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                <g id="Group_23863" data-name="Group 23863" transform="translate(17861 4413)">
                                    <circle id="Ellipse_99" data-name="Ellipse 99" cx="15" cy="15" r="15" transform="translate(-17861 -4413)" fill={bg ? bg : theme.colors.hover} />
                                    <circle id="Ellipse_98" className={'hover_circle'} data-name="Ellipse 99" cx="15" cy="15" r="0" transform="translate(-17861 -4413)" fill={hoverbg ? hoverbg : theme.colors.hover} />
                                    <g id="Group_23857" data-name="Group 23857" transform="translate(-17884.176 -4406.076)">
                                        <path id="Path_9210" data-name="Path 9210" d="M44.92,4.239a3.873,3.873,0,0,1-2.34-.782A3.874,3.874,0,0,1,41.033.39h-2.51V7.248l0,3.756a2.275,2.275,0,1,1-1.56-2.156V6.3a4.939,4.939,0,0,0-.724-.054A4.812,4.812,0,0,0,32.62,7.864a4.716,4.716,0,0,0,.213,6.5,4.9,4.9,0,0,0,.453.4,4.813,4.813,0,0,0,2.95,1,4.939,4.939,0,0,0,.724-.053,4.8,4.8,0,0,0,2.68-1.34,4.7,4.7,0,0,0,1.41-3.344l-.013-5.609a6.359,6.359,0,0,0,3.891,1.322v-2.5H44.92Z" fill={iconColor ? iconColor : theme.colors.hover}/>
                                    </g>
                                </g>
                            </svg>

                        </Link>
                    </li>
                }


            </ul>
        </StyledSocial>

    );
};


const StyledSocial = styled.div`
    margin-bottom: 0;

    .social {
        display: flex;
        flex-direction: row;
        gap: 15px;

        li {
            list-style: none !important;
            cursor: pointer;

            &:after {
                display: none !important;
            }

            &:before {
                display: none !important;
            }

            a {
                &:after {
                    display: none !important;
                }

                &:before {
                    display: none !important;
                }
            }
        }

        svg {
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            .hover_circle, path, rect {
                transition: ${theme.transition};
            }
        }

        li {
            margin-left: 0;
            margin-bottom: 0 !important;
            &:first-child {
                margin-left: 0;
            }

            a {
                &:hover {
                    svg {
                        .hover_circle {
                            r: 15px;
                        }

                        rect {
                            fill: ${theme.colors.white};
                        }

                        path {
                            fill: ${theme.colors.secondaryGreen} !important;
                        }


                    }
                }
            }
        }
    }

    ${devices.ResponsiveTabMobile} {
        .social {
            li {
                margin-left: 0;
            }
        }
    }
`;

export default React.memo(Social);














